import { render, staticRenderFns } from "./GClassManagementGroupProposal.vue?vue&type=template&id=e5ffba40&scoped=true&"
import script from "./GClassManagementGroupProposal.vue?vue&type=script&lang=ts&"
export * from "./GClassManagementGroupProposal.vue?vue&type=script&lang=ts&"
import style0 from "./GClassManagementGroupProposal.vue?vue&type=style&index=0&id=e5ffba40&lang=scss&scoped=true&"
import style1 from "./GClassManagementGroupProposal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ffba40",
  null
  
)

export default component.exports